import Spinner from 'ui/bend/animations/Spinner'

export default Spinner